import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const GUIDES = {
  outlook: {
    label: "Outlook / Microsoft 365",
    steps: [
      "In Outlook, click the gear icon → Mail → Rules → Add new rule.",
      "Name it \"Invoices to D20\". Condition: \"Has attachment\" (or \"From\" your suppliers).",
      "Action: \"Forward to\" → paste the D20 address → Save. Done.",
    ],
    tip: "Shared accounts mailbox? Ask your IT admin to add the forward in Exchange admin → Mailboxes → Mail flow. If forwards never arrive, IT needs to allow external auto-forwarding (Defender → Anti-spam outbound policy → Automatic forwarding: On).",
  },
  gmail: {
    label: "Gmail / Google Workspace",
    steps: [
      "In Gmail, click the gear icon → See all settings → Forwarding and POP/IMAP → Add a forwarding address → paste the D20 address.",
      "Gmail sends a confirmation code to D20 — it appears in \"Recently received\" below within a minute. Open it, copy the code, paste it into Gmail.",
      "Then Settings → Filters → Create a new filter: \"Has attachment\" → Forward it to the D20 address → Create filter.",
    ],
    tip: "Already connected Gmail above? You don't need this — the Gmail connector reads that inbox directly.",
  },
  other: {
    label: "Other email providers",
    steps: [
      "Open your mailbox settings and look for \"Forwarding\", \"Forwarders\" or \"Rules\" (Zoho, Fastmail, IONOS, cPanel all have one).",
      "Add a forward from your accounts / invoices mailbox to the D20 address.",
      "Or skip the setup: just forward invoice emails by hand whenever they arrive.",
    ],
    tip: "Any email system that can forward a message works — there's nothing to install.",
  },
};

export const ForwardingGuide = () => (
  <Tabs defaultValue="outlook" data-testid="forwarding-guide">
    <TabsList className="h-auto flex-wrap justify-start">
      {Object.entries(GUIDES).map(([k, g]) => <TabsTrigger key={k} value={k} className="text-xs" data-testid={`forwarding-guide-tab-${k}`}>{g.label}</TabsTrigger>)}
    </TabsList>
    {Object.entries(GUIDES).map(([k, g]) => (
      <TabsContent key={k} value={k} className="space-y-3 pt-2">
        <ol className="space-y-2">
          {g.steps.map((s, i) => (
            <li key={s} className="flex gap-2.5 text-sm">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/15 font-mono text-[11px] text-primary">{i + 1}</span>
              <span>{s}</span>
            </li>
          ))}
        </ol>
        <p className="text-xs text-muted-foreground">{g.tip}</p>
      </TabsContent>
    ))}
  </Tabs>
);
